import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { TokenService } from '../services/token.service';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const authGuard: CanActivateFn = (_route, _state): boolean | UrlTree => {
  const tokens = inject(TokenService);
  const router = inject(Router);

  const claims = tokens.decode();
  const expSeconds = claims?.exp;
  const hasValidExp = typeof expSeconds === 'number';
  const isExpired = !hasValidExp || expSeconds * 1000 <= Date.now();

  if (claims && !isExpired) return true;

  // Token missing, undecodable, or expired — clear and redirect.
  tokens.clear();
  return router.createUrlTree(['/login']);
};
